import gsap from 'gsap';
import Dispatch from '../core/Dispatch';
import { COMPONENT_INIT } from '../lib/events';

export default el => {

    const testimonials = [...el.children];

    let currentTestimonialIndex = 0;

    const showTestimonial = index => {
        if (index === currentTestimonialIndex) {
            return false;
        }

        const currentTestimonial = testimonials[currentTestimonialIndex];
        currentTestimonial.removeAttribute('aria-current');

        const nextTestimonial = testimonials[index];
        nextTestimonial.setAttribute('aria-current', 'true');

        currentTestimonialIndex = index;

        const { height: fromHeight } = el.getBoundingClientRect();

        nextTestimonial.hidden = false;

        const { height: toHeight } = nextTestimonial.getBoundingClientRect();

        gsap.timeline({
            onComplete() {
                currentTestimonial.hidden = true;
                gsap.set(el, { clearProps: 'height' });
            }
        })
            .set(nextTestimonial, {
                zIndex: parseInt(window.getComputedStyle(currentTestimonial).zIndex, 10) + 1
            }, 0)
            .fromTo(nextTestimonial, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.3
            }, 0)
            .fromTo(el, {
                height: fromHeight
            }, {
                height: toHeight,
                duration: 0.3
            }, 0);

        return true;
    };

    const prev = () => {
        if (!showTestimonial(currentTestimonialIndex > 0 ? currentTestimonialIndex - 1 : testimonials.length - 1)) {
            return;
        }

        testimonials[currentTestimonialIndex].querySelector('button[data-prev]').focus({ preventScroll: true });
    };

    const next = () => {
        if (!showTestimonial(currentTestimonialIndex < testimonials.length - 1 ? currentTestimonialIndex + 1 : 0)) {
            return;
        }

        testimonials[currentTestimonialIndex].querySelector('button[data-next]').focus({ preventScroll: true });
    };

    const onPrevButtonClick = e => {
        if (e.currentTarget.getAttribute('aria-disabled') === 'true') {
            return;
        }

        prev();
    };

    const onNextButtonClick = e => {
        if (e.currentTarget.getAttribute('aria-disabled') === 'true') {
            return;
        }

        next();
    };

    const init = () => {
        testimonials.forEach(testimonial => {
            testimonial.querySelector('button[data-prev]').addEventListener('click', onPrevButtonClick);
            testimonial.querySelector('button[data-next]').addEventListener('click', onNextButtonClick);
        });

        Dispatch.emit(COMPONENT_INIT);
    };

    const destroy = () => {
        testimonials.forEach(testimonial => {
            testimonial.querySelector('button[data-prev]').removeEventListener('click', onPrevButtonClick);
            testimonial.querySelector('button[data-next]').removeEventListener('click', onNextButtonClick);
        });
    };

    return {
        init,
        destroy
    };

};
